import React from 'react'
import PropTypes from 'prop-types'

class UnorderedList extends React.Component {
  render() {
    const listelements = this.props.items.map((item, index) => <li key={index.toString()}>{item}</li>)

    return <ul className="unorderedlist">{listelements}</ul>
  }
}

UnorderedList.propTypes = {
  items: PropTypes.array,
}

export default UnorderedList
